import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../GlobalReducer";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import {getProducts} from "../../api/catalog";

/**
 * Товары мини-карточек одного ответа консультанта, по id; товара, которого нет в каталоге, в ответе нет —
 * он остаётся ссылкой. Цены клиента и наличие в сообщениях не хранятся: они берутся из каталога
 * (/api/list-by-params, как в списке товаров) в момент показа, одним запросом на ответ.
 */
export default function useChatProducts(ids: number[], enabled: boolean): {products: Record<number, ProductInterface>, loading: boolean} {
    const [state] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const [products, setProducts] = useState<Record<number, ProductInterface>>({});
    const [loading, setLoading] = useState(false);
    const key = ids.join(',');

    useEffect(() => {
        if (!enabled || !key || !state.customer) {
            return;
        }
        const requested = key.split(',').map(Number);
        let cancelled = false;
        setLoading(true);

        getProducts({id: requested.map(String)}, state.customer).then(catalog => {
            if (cancelled) return;
            const byId: Record<number, ProductInterface> = {};
            (catalog.products || []).forEach(product => {
                if (requested.includes(product.id)) byId[product.id] = product;
            });
            setProducts(byId);
        }).catch(() => {
            // Каталог недоступен — карточки останутся ссылками
            if (!cancelled) setProducts({});
        }).finally(() => {
            if (!cancelled) setLoading(false);
        });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key, enabled, state.customer?.id]);

    return {products, loading};
}
